import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgProdEnvironment(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 0 18 24" {...props}>
      <path
        d="M20 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h16zm-1 2H5v14h14V5zm-9.572 7.336c1.424 0 2.112.824 2.112 2.056v1.624c0 1.24-.688 2.048-2.112 2.048-1.432 0-2.128-.808-2.128-2.048v-1.624c0-1.232.696-2.056 2.128-2.056zm4.936.064c1.456 0 2.336.848 2.336 2.784 0 1.784-.88 2.816-2.168 2.816H12.38v-5.6zm-4.936 1.12c-.584 0-.792.328-.792.944v1.464c0 .632.208.96.792.96.584 0 .776-.328.776-.96v-1.464c0-.616-.192-.944-.776-.944zm4.832.016h-.56v3.328h.56c.88 0 1.088-.816 1.088-1.704 0-.792-.208-1.624-1.088-1.624zM9.532 6.4c1.36 0 2.176.376 2.176 1.904 0 1.352-.776 1.872-2.104 1.872h-.52V12H7.756V6.4zm4.808 0c1.328 0 2.128.52 2.128 1.848 0 .944-.456 1.408-.904 1.608l1.2 2.144h-1.472l-.952-1.92h-.504V12h-1.32V6.4zM9.508 7.536h-.424v1.496h.424c.64 0 .856-.216.856-.752 0-.56-.216-.744-.856-.744zm4.776 0h-.448v1.408h.528c.488 0 .768-.176.768-.696 0-.56-.296-.712-.848-.712z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('ProdEnvironment')(SvgProdEnvironment);
